<template>
  <div>
    <vue-headful title="Vacature plaatsen" />
    <Header page_title="Vacature plaatsen" :link="{ name: 'job_step-1' }" />
    <div class="container-fluid app-body">
      <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="80" currentStep="3" />
      <form @change="onFormChange" @submit.prevent="onSubmit">
        <button type="submit" ref="submit" hidden>submit</button>
        <div class="sd-title medium" style="margin-bottom: 20px;">
          <span v-if="subBranch == 2" class="steps">4/4</span>
          <span v-else class="steps">5/5</span>
          {{ form.title }}
        </div>
        <div class="form-group">
          <textarea
            maxlength="500"
            class="form-control"
            :placeholder="textareaPlaceholder"
            rows="8"
            v-model="form.description"
            spellcheck="false"
          ></textarea>
        </div>
      </form>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          type="button"
          class="btn btn-warning btn-block"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
          @click="triggerSubmit"
        >
          Opslaan
        </button>
        <button
            v-if="isAdmin === 'true'"
            type="button"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            @click="onSubmitSilently"
        >
          Stil opslaan
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <svg-icon icon="success" />
            <div class="sd-title large text-uppercase bold text-white text-center" style="margin-bottom: 20px">
              Gelukt!
            </div>
            <p style="margin-bottom: 40px;">De vacature is geplaatst. Bekijk matches en sollicitaties via het dashboard.</p>
            <div class="container-fluid px-4 mx-2">
              <router-link
                  :to="{ name: 'company-dashboard', params: { matching_notification: true } }"
                  title="Bekijk"
                  class="btn btn-light btn-block"
                  v-ripple="'rgba(192, 189, 187, 0.35)'"
              >Naar het dashboard</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      done: null,
      form: {
        title: "",
        description: ""
      },
      isButtonDisabled: false,
      subBranch: localStorage.getItem('subBranch'),
      textareaPlaceholder: "",
      saveOnUpdate: false,
      isAdmin: localStorage.getItem('isAdmin')
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    form: {
      immediate: true,
      handler: function() {
        if (this.saveOnUpdate) {
          localStorage.setItem("job", JSON.stringify(this.form));
        }
      },
      deep: true
    }
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      if (localStorage.getItem("job")) {
        this.onFormChange();
        const job = JSON.parse(localStorage.getItem("job"));
        for (var obj in job) {
          if (job[obj]) {
            this.form[obj] = job[obj]; // update
          }
        }
        // any change on form should be saved
        this.saveOnUpdate = true;
      } else {
        this.$router.replace({ name: "job_step-1" });
      }
      this.$store.state.loading = false;

      this.textareaPlaceholder = "Meer informatie over de vacature en eventuele overige activiteiten naast lesuren \n(zoals vergaderingen).";

    },
    triggerSubmit() {
      if(this.isButtonDisabled) return;
      var elem = this.$refs.submit;
      elem.click();

      this.isButtonDisabled = true;
    },
    async onSubmit() {
      await this.saveJob();
    },
    async onSubmitSilently() {
      await this.saveJobSilently();
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
    async saveJob() {
      return new Promise(() => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/job";

        let formData = new FormData();
        for (var obj in this.form) {
          if (obj != "working_dates" && obj != "audience" && obj != "time_add_on") {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "working_dates") {
            let dates = JSON.stringify(this.form[obj]);
            formData.append(obj, dates);
          }
          if (obj == "audience") {
            var _audience = this.form[obj];
            for (var x = 0; x < _audience.length; x++) {
              formData.append("audience[]", _audience[x]);
            }
          }
          if (obj == "group") {
            var _group = this.form[obj];
            for (var x = 0; x < _group.length; x++) {
              formData.append("group[]", _group[x]);
            }
          }
          if(obj == "time_add_on") {
            let timeAddon = this.form[obj].replace(',','.');
            formData.append(obj, timeAddon);
          }
        }
        formData.append("branch", localStorage.getItem("branch"));

        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            console.log("success");
            this.done = true;
            localStorage.removeItem("form-pending");
            if (typeof dataLayer !== "undefined") {
              const isEdit = !!(this.form.id || this.form.job_id);
              dataLayer.push({
                event: isEdit ? "SchoolVacancyEdit" : "SchoolVacancyAdd",
                eventCategory: "School",
                eventAction: isEdit ? "School – Vacancy edit" : "School – Vacancy add",
                eventLabel: "",
                eventValue: "1"
              });
            }
            resolve();
          })
          .catch(() => {
            // console.log(error.response.data);
          });
      });
    },
    async saveJobSilently() {
      return new Promise(() => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/job/silent";

        let formData = new FormData();
        for (var obj in this.form) {
          if (obj != "working_dates" && obj != "audience" && obj != "time_add_on") {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "working_dates") {
            let dates = JSON.stringify(this.form[obj]);
            formData.append(obj, dates);
          }
          if (obj == "audience") {
            var _audience = this.form[obj];
            for (var x = 0; x < _audience.length; x++) {
              formData.append("audience[]", _audience[x]);
            }
          }
          if (obj == "group") {
            var _group = this.form[obj];
            for (var x = 0; x < _group.length; x++) {
              formData.append("group[]", _group[x]);
            }
          }
          if (obj == "time_add_on") {
            let timeAddon = this.form[obj].replace(',', '.');
            formData.append(obj, timeAddon);
          }
        }
        formData.append("branch", localStorage.getItem("branch"));

        this.$http
            .post(url, formData, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              console.log("success");
              this.done = true;
              localStorage.removeItem("form-pending");
              if (typeof dataLayer !== "undefined") {
                const isEdit = !!(this.form.id || this.form.job_id);
                dataLayer.push({
                  event: isEdit ? "SchoolVacancyEdit" : "SchoolVacancyAdd",
                  eventCategory: "School",
                  eventAction: isEdit ? "School – Vacancy edit" : "School – Vacancy add",
                  eventLabel: "",
                  eventValue: "1"
                });
              }
              resolve();
            })
            .catch(() => {
              // console.log(error.response.data);
            });
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // remove the form-pending if accessing sub page
    var subpages = ["job_step-1"];
    if (subpages.indexOf(to.name) > -1) {
      next();
    } else {
      this.savePending(to, from, next);
    }
  }
};
</script>

<style scoped>
textarea.form-control {
  min-height: 350px;
}
/deep/ .fullscreen-notif .svg-container {
  height: 100px;
  margin-bottom: 40px;
}
</style>
